export default __webpack_public_path__ + "static/media/sp-eq-with-cs.5ef05567.png";